export const APPLICATION_JSON_ACCEPT = 'application/json';
